import React from "react";
import { useNavigate } from "react-router-dom";

export const CompleteOrder = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen grid place-items-center bg-[#fff8e1]">
      <div className="app-container [font-family:'Nunito',Helvetica] text-[#5d4037] pb-40">
        {/* Topbar */}
        <div className="w-full flex items-center mt-4">
          <button onClick={() => navigate(-1)} className="ml-4 w-9 h-9 rounded-full bg-[#ccb357] grid place-items-center" aria-label="Back">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="#5d4037" strokeWidth="2" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></svg>
          </button>
          <h1 className="flex-1 text-center font-bold text-[18px]">Complete Order</h1>
          <div className="w-9" />
        </div>

        {/* Customer summary */}
        <div className="px-4 mt-4">
          <div className="relative rounded-[12px] bg-[#eadfb7] p-3 overflow-hidden">
            <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-[#6bbf59]" />
            <div className="flex items-start justify-between pl-3">
              <div>
                <p className="font-bold">Ken Brown</p>
                <p className="text-[13px] mt-1">ken456@gmai.com</p>
                <p className="text-[13px]">March 4, 2025 · 10:21 AM</p>
                <p className="text-[13px]">07012548935</p>
                <span className="inline-block mt-2 text-[12px] px-2 py-1 rounded-full bg-[#cfeccb] text-[#2f6b2b]">
                  Completed
                </span>
              </div>
              <p className="font-bold">₦12,000</p>
            </div>
          </div>
        </div>

        {/* Address */}
        <div className="px-4 mt-5">
          <p className="font-extrabold">Delivery Address</p>
          <div className="mt-2 rounded-[12px] bg-[#eadfb7] p-3">
            <p>123 Church Road</p>
            <p>Uyo, AkwaIbom State</p>
          </div>
        </div>

        {/* Items */}
        <div className="px-4 mt-5">
          <p className="font-extrabold">Items</p>
          <div className="mt-3 space-y-3">
            {[
              { name: "Pizza with coke", price: "₦12,000", img: "https://images.unsplash.com/photo-1548365328-9f547fb0959f?w=200&q=80&auto=format&fit=crop" },
              { name: "Banana cake", price: "₦12,000", img: "https://images.unsplash.com/photo-1605470207062-1be28f5f2c65?w=200&q=80&auto=format&fit=crop" },
            ].map((it, i) => (
              <div key={i} className="rounded-[10px] bg-[#eadfb7] px-2 py-2 flex items-center">
                <img alt="" src={it.img} className="w-12 h-12 rounded-[8px] object-cover" />
                <div className="ml-3">
                  <p className="font-bold text-[14px]">{it.name}</p>
                  <p className="text-[12px]">{it.price}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Actions */}
        <div className="px-4 mt-8 flex flex-col items-center">
          <button
            className="w-[290px] h-[56px] rounded-[28px] bg-[#f7c945] text-[#5d4037] font-bold hover:opacity-90"
          >
            Update Status
          </button>
          <button onClick={() => navigate(-1)} className="mt-4 text-[#c34040] underline">
            Cancel
          </button>
        </div>

        {/* Brown bar + white */}
        <div className="fixed bottom-3 md:bottom-6 left-1/2 -translate-x-1/2 w-full max-w-[1440px] xl:max-w-[1600px] px-6 md:px-10 xl:px-16">
          <div className="h-[22px] bg-[#5d4037] flex items-center justify-center">
            <div className="w-[120px] h-[6px] rounded-full bg-white" />
          </div>
        </div>
      </div>
    </div>
  );
};
